import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { ThemeProvider } from "./context/ThemeContext";
import { AuthProvider } from "./context/AuthContext";
import Navbar from "./components/Navbar"; // Kept if needed elsewhere, but effectively removed from render
import MainLayout from "./components/layouts/MainLayout";
import PublicLayout from "./components/layouts/PublicLayout";
import ProtectedRoute from "./components/routes/ProtectedRoute";
import AdminRoute from "./components/routes/AdminRoute";
import Landing from "./pages/Landing";
import Auth from "./pages/Auth";
import ChallengeMenu from "./pages/challenge-modes/ChallengeMenu";
import ClassicChallenge from "./pages/challenge-modes/ClassicChallenge";
import BlitzChallenge from "./pages/challenge-modes/BlitzChallenge";
import LadderMode from "./pages/LadderMode";
import Dashboard from "./pages/Dashboard";
import Leaderboard from "./pages/Leaderboard";
import AdminDashboard from "./pages/AdminDashboard";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <div className="app-container">
            <Routes>
              {/* Public Routes without Navbar */}
              <Route element={<PublicLayout />}>
                <Route path="/auth" element={<Auth />} />
              </Route>

              {/* Main App Layout with Navbar */}
              <Route element={<MainLayout />}>
                {/* Public Accessible in Main Layout */}
                <Route path="/" element={<Landing />} />
                <Route path="/leaderboard" element={<Leaderboard />} />

                {/* Protected Section */}
                <Route element={<ProtectedRoute />}>
                  <Route path="/dashboard" element={<Dashboard />} />

                  {/* Challenge Routes */}
                  <Route path="/challenge" element={<ChallengeMenu />} />
                  <Route path="/challenge/classic" element={<ClassicChallenge />} />
                  <Route path="/challenge/blitz" element={<BlitzChallenge />} />
                  <Route path="/challenge/ladder" element={<LadderMode />} />
                </Route>

                {/* Admin Access Only */}
                <Route element={<AdminRoute />}>
                  <Route path="/admin" element={<AdminDashboard />} />
                </Route>
              </Route>
            </Routes>
          </div>
          <Toaster position="bottom-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
